// extracted by mini-css-extract-plugin
module.exports = {"collapse_btn":"_3HSjDrJkf3IG2JQOJ25ZYk","outer_size_s":"_23cJTCfNPVCVbGhm7Xql-m"};